export const NOTIFICATION = 'NOTIFICATION';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export const NOTIFICATION_DISMISS_ACTION = `${NOTIFICATION}/DISMISS`;
export const NOTIFICATION_SUCCESS_ACTION = `${NOTIFICATION}/${SUCCESS}`;
export const NOTIFICATION_ERROR_ACTION = `${NOTIFICATION}/${ERROR}`;
